module.exports = __webpack_public_path__ + "public/Icons/leftArrowBtn.png?9a10ca75";